import createAction from '../createAction.js';
import primitiveDuckCreator from './primitiveDuckCreator.js';
import hasStore from './checks/hasPayloadTypeCheck.js';

const legacyReducer = (state, action, duck) => {
    switch (action.type) {
        case duck.types.SET_STRING: {
            hasStore(duck, action, 'string');
            return action.payload;
        }

        default:
            return state;
    }
};

const rtkReducer = (builder, duck) => {
    builder.addCase(duck.types.SET_STRING, (state, action) => {
        hasStore(duck, action, 'string');
        return action.payload;
    });
};

const stringDuckCreator = (options) =>
    primitiveDuckCreator(options).extend({
        primitiveName: 'stringDuckCreator',
        types: ['SET_STRING'],
        reducer: options.useRTKReducer ? rtkReducer : legacyReducer,
        creators: (duck) => ({
            setString: createAction(duck.types.SET_STRING),
        }),
    });

export { stringDuckCreator as default };
